import { render, staticRenderFns } from "./AdminViewOrganisation.vue?vue&type=template&id=08c1446c&"
import script from "./AdminViewOrganisation.vue?vue&type=script&lang=js&"
export * from "./AdminViewOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports